import type { CanvasArchetype, CanvasType } from "../types";

/** Map the editor's legacy labels to the current canvas API archetypes. */
export function canvasTypeToArchetype(type: CanvasType): CanvasArchetype {
  switch (type) {
    case "report":
      return "report";
    case "dashboard":
      return "dashboard";
    case "browse":
      return "browse";
    case "entry":
    case "wizard":
    default:
      return "data_entry";
  }
}

/** Read current API responses while retaining compatibility with legacy rows. */
export function canvasTypeFromDefinition(canvas: {
  canvas_type?: string | null;
  archetype?: CanvasArchetype | null;
}): CanvasType {
  if (
    canvas.canvas_type &&
    ["entry", "browse", "report", "dashboard", "wizard"].includes(
      canvas.canvas_type,
    )
  ) {
    return canvas.canvas_type as CanvasType;
  }
  switch (canvas.archetype) {
    case "report":
      return "report";
    case "dashboard":
      return "dashboard";
    case "browse":
      return "browse";
    case "data_entry":
    default:
      return "entry";
  }
}
